module.exports = __webpack_public_path__ + "static/media/11. Speaker Crispino Lobo.72f86af4.png";